<button (click)="onClick($event)" class="semantic-button">
  <ng-content></ng-content>
  <span class="screenreader">
    Click to Sort, currently {{ ariaSort || "unsorted" }}
  </span>
  <span class="material-icons" aria-hidden="true">
    {{ materialSortIcon$ | async }}
  </span>
</button>
